import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import AppRoutes from './routes/AppRoutes';
import Header from './components/Header/Header';
import Sidebar from './components/Sidebar/Sidebar';
import Footer from './components/Footer/Footer';
import { Box } from '@mui/material';

function App() {
  const location = useLocation();
  const token = localStorage.getItem('token');
  const isLoginPage = location.pathname === '/';
  const isContratoAssinaturaPage = location.pathname.startsWith('/contratos/assinar/');
  const isReservaPublica = location.pathname.startsWith('/reservar');
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);

  // Se está na página de login, assinatura de contrato ou reserva pública, só renderiza as rotas
  if (isLoginPage || isContratoAssinaturaPage || isReservaPublica) {
    return <><AppRoutes /><Analytics /></>;
  }

  // Se não tiver token e não for página de login, redireciona pro login
  if (!token) {
    return <Navigate to="/" replace />;
  }

  const sidebarWidth = sidebarCollapsed ? 72 : 240;

  return (
    <>
    <Box display="flex" sx={{ m: 0, p: 0 }}>
      <Sidebar onCollapsedChange={setSidebarCollapsed} />
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          height: '100vh',
          bgcolor: "#f5f5f5",
          ml: `${sidebarWidth}px`,
          m: 0,
          p: 0,
          transition: 'margin 0.3s ease',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}
      >
        <Header sidebarWidth={sidebarWidth} />
        <Box 
          component="section" 
          sx={{ 
            pt: 'calc(64px + 24px)',
            px: 3,
            pb: 3,
            height: 'calc(100vh - 64px)',
            maxWidth: '100%',
            boxSizing: 'border-box',
            overflowY: 'auto',
            overflowX: 'hidden',
            '&::-webkit-scrollbar': {
              width: '12px',
            },
            '&::-webkit-scrollbar-track': {
              background: '#f1f1f1',
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#FF8C00',
              borderRadius: '6px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: '#e07b00',
            },
          }}
        >
          <AppRoutes />
        </Box>
        <Footer />
      </Box>
    </Box>
    <Analytics />
    </>
  );
}

export default App;
